module.exports = __webpack_public_path__ + "img/jj1.caed148a.png";